// @ts-nocheck
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { colors } from '@lmc/common/constants'
import { Icon } from '../../generic'
import { theme } from '@lmc/ui-kit'

export default function SingleCheckboxField({
  disabled,
  errors,
  formKey,
  label,
  leftIcon,
  options,
  values,
  compact,
  onChange,
  ...props
}) {
  const currentValue = get(values, formKey)
  const error = get(errors, formKey)

  let isChecked
  if (options && options.on) {
    isChecked = currentValue === options.on
  } else {
    isChecked = !!currentValue
  }

  let borderColor
  if (error) {
    borderColor = colors.red
  } else if (disabled) {
    borderColor = colors.darkgrey
  } else if (isChecked) {
    borderColor = theme.color.status.primary
  } else {
    borderColor = colors.grey
  }

  const width = compact ? null : '100%'
  const activeColor = disabled ? colors.darkgrey : theme.color.status.primary

  return (
    <div
      className={disabled ? 'lmc-option-field__disabled' : 'lmc-option-field'}
      onClick={() => {
        if (!disabled) {
          onChange({
            key: formKey,
            value: getChangeValue(options, isChecked),
          })
        }
      }}
      style={{ ...styles.wrapper, borderColor, width }}
      data-testid={props['data-testid']}
    >
      <div style={styles.valueContainer}>
        {leftIcon && (
          <Icon
            name={getLeftIcon(leftIcon, isChecked)}
            fill={isChecked ? colors.darkblue : colors.darkgrey}
            size={24}
            style={{
              ...styles.icon,
              marginRight: 8,
            }}
          />
        )}
        <span
          style={{
            ...styles.checkboxLabel,
            color: disabled ? colors.darkgrey : null,
            fontWeight: 400,
          }}
        >
          {label}
        </span>
      </div>
      <Icon
        name={isChecked ? 'checkbox-on' : 'checkbox-off'}
        fill={isChecked ? activeColor : null}
        size={24}
        style={styles.icon}
      />
    </div>
  )
}

function getChangeValue(options, isChecked) {
  if (options && options.on) {
    return isChecked ? options.off : options.on
  } else {
    return isChecked ? false : true
  }
}

function getLeftIcon(leftIcon, isChecked) {
  if (leftIcon.on) {
    return isChecked ? leftIcon.off : leftIcon.on
  } else {
    return leftIcon
  }
}

const styles = {
  checkboxLabel: {
    alignSelf: 'center',
    display: 'block',
    marginRight: 5,
  },
  error: {
    color: colors.red,
    fontSize: 11,
    paddingTop: 2,
  },
  icon: {
    flexShrink: 0,
  },
  valueContainer: {
    alignItems: 'center',
    display: 'flex',
    userSelect: 'none',
  },
  wrapper: {
    marginBottom: 0,
  },
}

SingleCheckboxField.propTypes = {
  compact: PropTypes.bool,
  leftIcon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      on: PropTypes.string.isRequired,
      off: PropTypes.string.isRequired,
    }),
  ]),
  options: PropTypes.shape({
    on: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    off: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  }),
}
